/* eslint-disable react/no-danger */
import React from 'react';

import { BenefitsData } from './models';

import './CustomProductBenefits.scss';

interface CustomProductBenefitsProps {
  data?: BenefitsData;
}

const CustomProductBenefits = ({ data }: CustomProductBenefitsProps) => {
  const { heading, headingColor, backgroundGradient, desktopImage, mobileImage } = data || {};

  return (
    <section
      className="cds-page-block media-plus-text-block cds-section--transparent-mode custom-product-benefits"
      style={{ backgroundImage: backgroundGradient }}
    >
      <div className="cds-container cds-container--max-grid cds-page-block__content">
        {mobileImage && (
          <div className="cds-heading-block cds-page-block__heading cds-heading-block--align-center">
            <h2
              className="cds-typography cds-heading-block__title cds-typography--variant-headline cds-typography--variant-headline-xl cds-typography--wrapping-default cds-typography--weight-bold"
              style={{ color: headingColor }}
            >
              {heading}
            </h2>
          </div>
        )}
        {mobileImage && (
          <img
            className="custom-product-benefits__mobile-image"
            src={mobileImage?.url}
            alt="Mobile Benefits"
            loading="eager"
            fetchPriority="high"
          />
        )}
        {desktopImage && (
          <img
            className="custom-product-benefits__desktop-image"
            src={desktopImage?.url}
            alt="Desktop Benefits"
            loading="eager"
            fetchPriority="high"
          />
        )}
      </div>
    </section>
  );
};

CustomProductBenefits.displayName = 'CustomProductBenefits';
export default CustomProductBenefits;
